/**
 * @return {String}
 */
export default function loginUrl() {
  return `/login`;
}



// WEBPACK FOOTER //
// ./src/utils/url/loginUrl.js